/* eslint-disable no-undef */
// userSaga.js
import { call, put, takeEvery } from 'redux-saga/effects';
import { loginRedirectRequest } from './Actions';
import { LOGIN_REQUEST } from './Constant';
import axios from 'axios';
import { Modal } from 'antd';
import { jwtDecode as jwt_decode } from 'jwt-decode';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

function* login(action) {

    try {
        let data;
        let decode;
        if (action.loginType == 'email') {
            data = {
                'email': action.payload.email,
                'password': action.payload.password,
                'strategy': 'local'
            };
        } else if (action.loginType == 'phone') {
            data = {
                'cellphone': action.payload.phone,
                'password': action.payload.password,
                'strategy': 'localmobile'
            };
        }

        const url = `${process.env.REACT_APP_API_BASE_URL}/authentication`;

        // Example headers - You can add more headers as per your requirement
        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            limit: 1000,
            skip: 0,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        // const data = {};  // Data you want to send with the POST request (can be empty for a simple POST)


        const response = yield call(axios.post, url, data, { headers });

        if (response.status === 200 || response.status === 201) {
            sessionStorage.setItem('jwt', response.data.accessToken);
            decode = jwt_decode(response.data.accessToken);
            if (decode.permissions === 'patient') {
                localStorage.setItem('NEWUSER_ID', decode.userId);
                sessionStorage.setItem('USER_ID', decode.userId);
                const accessToken = sessionStorage.getItem('jwt');
                if (accessToken) {
                    const patientDetailsUrl = `${process.env.REACT_APP_API_BASE_URL}/patientdetails?accessToken=${accessToken}`;
                    const headers = {
                        'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                        'Content-Type': 'application/json',
                        Authorization: sessionStorage.jwt,
                        'x-api-version': process.env.REACT_APP_X_API_VERSION,
                    };
                    const response = yield call(axios.get, patientDetailsUrl, { headers });
                    if (response.status == 200 || response.status == 201) {
                        let logindata = response.data;

                        localStorage.setItem('PATIENT_IDS', logindata.data[0].id);
                        sessionStorage.setItem('PATIENT_ID', logindata.data[0].id);
                        localStorage.setItem('FAMILY_PATIENT_ID', logindata.data[0].id);
                        localStorage.setItem('IS_INTERNATIONAL', logindata.data[0].isInternational);
                        localStorage.setItem('PARENT_EMAIL', logindata.data[0].primaryEmail);
                        localStorage.setItem('PARENT_PHONE', logindata.data[0].primaryContact);
                        localStorage.setItem('PARENT_PATIENT_ID', logindata.data[0].id);
                        localStorage.setItem('PARENT_USERID', logindata.data[0].usersId);
                        localStorage.setItem('PARENT_ID', logindata.data[0].parentId);
                        localStorage.setItem('REQ_PATIENT_ID', logindata.data[0].id);

                        yield put(loginRedirectRequest('/'));
                        // yield put(navigate('/about'));
                        // action.history.push('/')

                        // if (localStorage.getItem('SCHEDULE_ID') !== 'null') {
                        //   // This is done if the log in for the booking appointment flow
                        //   yield put(push('/scheduledetail'));
                        // }
                        // if (localStorage.getItem('TOKEN') === 'null') {
                        //   yield put(push('/online-doctors-consultation'));
                        // } else if (localStorage.getItem('DEMAND') === 'true') {
                        //   localStorage.removeItem('DEMAND');
                        //   yield put(push('/newtimeslot'));
                        // } else if (sessionStorage.getItem('FLAG_DOC_CAMPAIGN') === 'true') {
                        //   yield put(push(`/doctor/${localStorage.getItem('DOC_CAMPAIGN_ID')}`));
                        // } else if (sessionStorage.getItem('FLAG_DOC_CAMPAIGN') === 'departmentDoctor') {
                        //   yield put(
                        //     push(
                        //       `/online-doctor-consultation/${localStorage.getItem('DEPARTMENT_LISTING_DOC')}`,
                        //     ),
                        //   );
                        // } else if (localStorage.getItem('TOKEN') === 'true') {
                        //   localStorage.removeItem('TOKEN');
                        //   try {
                        //     const type = localStorage.getItem('TYPE');
                        //     let sloturl;
                        //     if (type === true) {
                        //       sloturl = `${API_BASE_URL}/schedules?doctorsId=${localStorage.getItem(
                        //         'DOC_ID',
                        //       )}&consultationTypeId=1&date[$gte]=${localStorage.getItem(
                        //         'START_DATE',
                        //       )}&date[$lte]=${localStorage.getItem(
                        //         'END_DATE',
                        //       )}&$sort[date]=1&$sort[time]=1&$limit=1000`;
                        //     } else {
                        //       sloturl = `${API_BASE_URL}/schedules?doctorsId=${localStorage.getItem(
                        //         'DOC_ID',
                        //       )}&consultationTypeId=3&date[$gte]=${localStorage.getItem(
                        //         'START_DATE',
                        //       )}&date[$lte]=${localStorage.getItem(
                        //         'END_DATE',
                        //       )}&$sort[date]=1&$sort[time]=1&$limit=1000`;

                        //       // when book appointment is clicked
                        //     }
                        //     const slotresponse = yield call(fetch, sloturl, {
                        //       method: 'GET',
                        //       headers: new Headers({
                        //         'Content-Type': 'application/json',
                        //         Authorization: sessionStorage.jwt,
                        //         'api-header-security': process.env.API_HEADER_SECURITY,
                        //       }),
                        //     });
                        //     if (slotresponse.status === 200) {
                        //       let timeslots;
                        //       yield slotresponse.json().then((body) => {
                        //         timeslots = body.data;
                        //         return null;
                        //       });
                        //       yield put({ type: TIMESLOTS_RECIVED, slots: timeslots });

                        //       yield put(push('/timeslot'));
                        //     }
                        //   } catch (error) {
                        //     throw error;
                        //   }
                        // } else {
                        //   yield put(push('/'));
                        // }

                    } else if (response.status === 204) {
                        Modal.warning({
                            title: 'Complete your profile',
                            content: 'Please complete your profile details here...',
                        });
                        yield put(loginRedirectRequest('/addprofile'));
                    } else {
                        sessionStorage.removeItem('jwt');
                    }
                }
            }

            // yield put(familyTreeRequestSuccess(response.data));
        } else {
            // yield put(familyTreeRequestError('An error occurred.'));
        }

    } catch (error) {
        
        const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
        const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

        if (error.response) {
            // Handle specific error cases
            if (error.response.status === 401) {
                Modal.error({
                    title: langdata.AuthenticationFailed || 'Authentication Failed',
                    content: langdata.InvalidCredentials || 'Invalid email/phone or password. Please try again.',
                });
            } else if (error.response.status === 400) {
                Modal.error({
                    title: langdata.InvalidInput || 'Invalid Input',
                    content: langdata.CheckCredentials || 'Please check your credentials and try again.',
                });
            } else {
                Modal.error({
                    title: langdata.Error || 'Error',
                    content: langdata.LoginError || 'An error occurred during login. Please try again later.',
                });
            }
        } else {
            Modal.error({
                title: langdata.NetworkError || 'Network Error',
                content: langdata.NetworkErrorMessage || 'Unable to connect to the server. Please check your internet connection.',
            });
        }
        yield put({ type: 'LOGIN_REQUEST_ERROR', payload: error.message });
    }

}

// Watcher Saga
export function* watchFetchLogin() {
    yield takeEvery(LOGIN_REQUEST, login);
}
